import type { I18nFn } from '#/i18n/types/I18nFn';

export function TIMES_OF_DAY(i18n: I18nFn) {
  return {
    WEEKDAYS_DAYTIME: i18n('Weekdays - Daytime'),
    WEEKDAYS_EVENINGS: i18n('Weekdays - Evenings'),
    WEEKENDS_DAYTIME: i18n('Weekends - Daytime'),
    WEEKENDS_EVENINGS: i18n('Weekends - Evenings'),
  };
}

export type TimeOfDay = keyof ReturnType<typeof TIMES_OF_DAY>;

export function TIMES_OF_DAY_OPTIONS(i18n: I18nFn) {
  return Object.entries(TIMES_OF_DAY(i18n)).map(([key, value]) => ({
    name: key,
    label: value,
  }));
}
